import { getFormattedAddress } from '../../../../../../../Helpers/AddressHelper';

export const mapExistingAddressesToSelect = addresses => {
  return [
    { key: 0, value: null, displayName: '' },
    ...addresses?.map(address => {
      return { key: address.id, value: address.id, displayName: getFormattedAddress(address) };
    }),
  ];
};
